// Windy override
#device-desktop #plugin-windy-plugin-fxc-soundings .plugin__content {
  padding: 25px !important;
  display: grid;
  grid-template-rows: auto 1fr;
}

#device-mobile #plugin-windy-plugin-fxc-soundings .plugin__content {
  pointer-events: initial;
}

// Update available
#wsp-update {
  background-color: var(--color-warning-moderate);
  color: var(--color-black);
  text-align: center;
}

// flyXC icon on desktop.
#wsp-icon {
  position: relative;
  top: -3px;
  margin-right: 0.3em;
  vertical-align: middle;
}

// dev badge for the icon.
#wsp-dev {
  position: absolute;
  bottom: -3px;
  left: 35px;
}

#wsp-version {
  margin-left: 0.5em;
}

// Model details, desktop only.
#wsp-model {
  padding: 0 0 1em;

  dl {
    display: grid;
    grid-gap: 4px 16px;
    grid-template-columns: max-content;
  }

  dt {
    font-style: italic;
  }

  dd {
    font-weight: 500;
    grid-column-start: 2;
  }
}

// Favorite shortcuts, desktop only.
#wsp-flyto {
  .button {
    line-height: 1em;
    padding: 0.3em 0.6em;
    margin: 0.1em 0.2em;
  }

  .selected {
    background-color: var(--color-orange);
  }

  padding-top: 0.5em;
}

// Zomm in and out.
#wsp-zoom {
  cursor: pointer;
  transform: scale(1.2);

  rect {
    fill: #fff;
  }

  path {
    fill: var(--color-orange);
  }
}

// Resize the mobile layout.
#wsp-resize {
  cursor: move;

  rect {
    fill: lightgray;
    stroke: black;
    stroke-width: 0.3px;
  }

  line {
    stroke: darkgrey;
    stroke-width: 2px;
  }
}

#wsp-sounding {
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  p {
    margin: 0 0 0.3em;
    padding: 0;
  }

  a {
    font-weight: bold;
  }

  #device-desktop & {
    display: grid;
    justify-items: stretch;
    // graph, favorites, sponsors
    grid-template-rows: auto 1fr auto;

    #wsp-sponsor {
      padding: 0.5em;
      text-align: center;
      background-color: var(--color-gray-dark);
    }
  }

  .wsp-message {
    display: grid;
    align-items: center;
    text-align: center;
    border: 1px solid lightgray;
  }

  svg {
    touch-action: none;

    text {
      fill: var(--color-text-primary);

      a {
        fill: var(--color-text-link);
      }
    }
  }

  p.header {
    padding-bottom: 1em;
  }

  .graph {
    shape-rendering: geometricprecision;

    .background {
      fill: white;
      stroke: none;
    }

    .border {
      fill: none;
      stroke: gray;
      stroke-width: 1;
    }

    text {
      fill: black;
      stroke: none;
      filter: url(#outline);
      font-size: 13px;
    }

    .cursor {
      line {
        stroke: darkgray;
        stroke-dasharray: 2;
      }

      text {
        dominant-baseline: hanging;

        &.altitude,
        &.speed {
          text-anchor: end;
        }
      }

      &.bottom text {
        dominant-baseline: auto;
      }
    }

    .surface {
      fill: #8f6d4d;
    }

    .line {
      stroke-width: 3;
    }

    path {
      fill: none;
      stroke-linejoin: round;
    }

    .boundary {
      stroke: darkgray;
      stroke-width: 0.5px;
    }

    &.skewt {
      #wsp-watermark {
        text {
          text-anchor: middle;
        }

        .title {
          fill: #ddd;
          font-size: 30px;
          dominant-baseline: auto;
        }

        .subtitle {
          fill: #999;
          font-size: 13px;
          dominant-baseline: hanging;
        }

        #device-desktop & {
          text {
            fill: #eee;
          }

          .title {
            dominant-baseline: middle;
          }

          .subtitle {
            fill: none;
          }
        }
      }

      .temperature text,
      text.temperature {
        fill: red;
      }

      .dewpoint text,
      text.dewpoint {
        fill: steelblue;
      }

      .isotherm text {
        fill: darkred;
      }

      .line {
        .temperature {
          stroke: red;
        }

        .dewpoint {
          stroke: steelblue;
        }
      }

      .axis {
        path {
          stroke-width: 0.3;
        }

        .dry-adiabatic {
          stroke: green;
        }

        .wet-adiabatic {
          stroke: green;
          stroke-dasharray: 4 6;
        }

        .isotherm {
          stroke: darkred;

          .zero {
            stroke-width: 1;
            font-weight: bold;
          }
        }

        .altitude {
          stroke: lightgray;
        }

        .isohume {
          stroke: blue;
          stroke-dasharray: 4 6;
        }

        text {
          &.temperature {
            text-anchor: middle;
            dominant-baseline: middle;
          }
        }
      }

      .cloud {
        .cirrus {
          filter: url(#outline);
        }
      }

      .parcel {
        .line {
          stroke: green;
        }

        .isohume {
          stroke: steelblue;
          stroke-width: 1px;
          stroke-dasharray: 3;
        }

        text {
          text-anchor: end;
          dominant-baseline: hanging;
        }

        path.cumulus {
          stroke: #030104;
          fill: lightyellow;
          stroke-width: 2;
        }

        rect.cumulus {
          opacity: 0.8;
          fill: url(#hatch);
        }
      }
    }

    &.wind {
      text.speed {
        fill: purple;
      }

      .line {
        &.speed {
          stroke: purple;
        }
      }

      .axis {
        .speed {
          stroke: lightgray;
        }
      }
    }
  }

  .parcel {
    stroke-width: 3;
    fill: none;
    stroke-linejoin: round;

    &.trajectory {
      stroke: rgb(89, 156, 0);
    }

    &.isohume {
      stroke-width: 1;
      stroke: gray;
      stroke-dasharray: 4;
    }
  }
}

.layer-icon {
  cursor: pointer;
  width: 32px;
  height: 32px;
  opacity: 0.3;

  rect {
    fill: transparent;
  }

  &:hover {
    opacity: 0.8;
  }

  &.active {
    opacity: 1;

    path {
      fill: var(--color-orange);
    }
  }
}

// Mobile bottom bar.
#plugin-windy-plugin-fxc-soundings {
  &.plugin-mobile-bottom-small {
    padding: 0;
    max-height: fit-content !important;

    .desktop-only {
      display: none;
    }

    .plugin__content {
      position: initial;
    }

    #wsp-favorite {
      display: grid;
      grid-template-columns: 1fr 1fr auto;
      padding: 10px 0;
      margin: 0;
      background-color: var(--color-red);

      & > div {
        cursor: pointer;
      }

      .select {
        width: 100%;
        text-align: center;
        white-space: nowrap;

        &:before,
        &:after {
          display: inline-block;
          position: relative;
          top: -2px;
        }

        &:after {
          transform-origin: center center;
          transition: transform 0.3s;
          transform: rotate(-90deg);
        }

        &.active::after {
          transform: rotate(0);
        }

        small {
          padding: 0 5px;
          display: inline-block;
          max-width: 120px;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }

    .options {
      padding: 5px;
      width: 100%;
      background-color: var(--color-red);
      text-align: center;
    }

    .options > span {
      display: inline-block;
      border-radius: 1em;
      padding: 2px 5px;
      margin: 0 5px;
    }

    .options > span.selected {
      background-color: var(--color-red-light);
    }
  }

  .plugin__content {
    select {
      font-size: 1rem;
    }
  }
}
